var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.subscribed)?_vm._t("form",null,{"subscription":_vm.subscription,"subscribe":_vm.subscribe}):_vm._t("thank-you")],2)}
var staticRenderFns = []

export { render, staticRenderFns }